import Feature25 from './Feature25'
export default Feature25
